import {Component, computed, inject, input, LOCALE_ID, Signal} from '@angular/core';
import {formatDate} from '@angular/common';

import {OptionsFacade} from '@selpia/options/data-access';
import {AppConfigFacade} from '@selpia/app-config/data-access';
import {PerspectiveFacade} from '@selpia/perspective/data-access';
import {Formatter} from '@selpia/shared/utils';
import {TitleData} from '../model/title-data.model';

@Component({
  selector: 'lib-feature-description',
  templateUrl: './feature-description.component.html',
  styleUrl: './feature-description.component.scss',
  host: {
    'data-test': 'tile-grid-description',
  },
})
export class FeatureDescriptionComponent {
  readonly #optionsFacade = inject(OptionsFacade);
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #perspectiveFacade = inject(PerspectiveFacade);
  readonly #locale = inject(LOCALE_ID);

  readonly itemName = input<string>();

  readonly formatString = computed(() => {
    const itemName = this.itemName();
    const titleTemplate = this.#appConfigFacade.titleTemplate();
    if (!itemName) {
      return titleTemplate;
    }
    return titleTemplate?.replace('measure', 'itemName');
  });

  protected readonly title = computed(() => {
    const period = this.#optionsFacade.focusPeriod();
    const measure = this.#optionsFacade.focusMeasure()?.fullName;
    const dateObject = this.#perspectiveFacade.date();

    const levelName = this.#perspectiveFacade.perspective()?.focusDimensionLevel.name;

    const itemName = this.itemName() || '';

    const dateFormat = this.#appConfigFacade.dateFormat();
    const formatString = this.formatString();

    if (!period || !measure || !dateObject || !levelName) {
      return '';
    }

    const date = dateFormat ? formatDate(dateObject, dateFormat, this.#locale) : dateObject.toLocaleString();

    if (!formatString) {
      return `${period} ${measure}`;
    }

    const data: TitleData = {period, measure, date, levelName, itemName};
    return Formatter.formatByString(formatString, data);
  });
}
